// extracted by mini-css-extract-plugin
export default {"title":"_78d414b8ff","bld":"e2a4ac1481"};